import Image from 'next/image';
import styles from './RoundedIconButton.module.scss';

export const RoundedIconButton = ({
  onClick,
  src,
  alt,
  className,
  disabled,
}: {
  onClick: any;
  src: string;
  alt: string;
  className?: string;
  disabled?: boolean;
}) => (
  <div className={[styles.roundedIconButton, className].filter(Boolean).join(' ')}>
    <button
      onClick={onClick}
      className={styles.button}
      disabled={disabled}
      aria-disabled={disabled}
    >
      <Image src={src} width={24} height={24} alt={alt} />
    </button>
  </div>
);
